/** 오늘(로컬 타임존) 날짜를 서버 포맷 YYYY-MM-DD 로 반환 — 시작일 기본값·최소값용. */
export function todayISO(): string {
  const now = new Date();
  const offset = now.getTimezoneOffset() * 60_000;
  return new Date(now.getTime() - offset).toISOString().slice(0, 10);
}
